import { render } from "./Work.vue?vue&type=template&id=d69120e0&bindings={}"
import script from "./Work.vue?vue&type=script&lang=ts"
export * from "./Work.vue?vue&type=script&lang=ts"

import "./Work.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script